module.exports = __webpack_public_path__ + "img/logo_aragon_blanco.d3d6ebab.png";